import Cookies from "js-cookie";

const COOKIE_OPTIONS = {
  expires: 365 * 3,
  path: "/",
  sameSite: "Strict",
  secure: typeof window !== "undefined" && window.location.protocol === "https:"
};

const normalizeId = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).trim();
};

export const persistUserIdentity = (user = {}) => {
  const userId = normalizeId(
    user.id ??
      user.user_id ??
      user.userId ??
      user.uid
  );
  const email = String(user.email ?? "").trim();
  const name = String(user.name ?? "").trim();

  try {
    if (userId) {
      localStorage.setItem("user_id", userId);
      localStorage.setItem("userId", userId);
      localStorage.setItem("uid", userId);
      Cookies.set("user_id", userId, COOKIE_OPTIONS);
      Cookies.set("uid", userId, COOKIE_OPTIONS);
    }

    if (email) {
      localStorage.setItem("user_email", email);
    }

    if (name) {
      localStorage.setItem("user_name", name);
    }
  } catch {
  }
};

export const clearStoredIdentity = () => {
  try {
    localStorage.removeItem("user_id");
    localStorage.removeItem("userId");
    localStorage.removeItem("uid");
    localStorage.removeItem("user_email");
    localStorage.removeItem("user_name");
  } catch {
  }

  try {
    Cookies.remove("user_id", { path: "/" });
    Cookies.remove("uid", { path: "/" });
  } catch {
  }
};

export const readStoredUserId = () =>
  normalizeId(
    (() => {
      try {
        return (
          localStorage.getItem("user_id") ||
          localStorage.getItem("userId") ||
          localStorage.getItem("uid") ||
          Cookies.get("user_id") ||
          Cookies.get("uid") ||
          ""
        );
      } catch {
        return "";
      }
    })()
  );
